/** A shared ladder; every ranged stage needs two credited eliminations. */
export const ARMS_RACE_LADDER = [
  { weaponId: 'pistol', killsRequired: 2 },
  { weaponId: 'revolver', killsRequired: 2 },
  { weaponId: 'uzi', killsRequired: 2 },
  { weaponId: 'ak47', killsRequired: 2 },
  { weaponId: 'm16', killsRequired: 2 },
  { weaponId: 'm1', killsRequired: 2 },
  { weaponId: 'sniper', killsRequired: 2 },
  { weaponId: 'sawed-off', killsRequired: 2 },
  { weaponId: 'military-shotgun', killsRequired: 2 },
  { weaponId: 'grenade-launcher', killsRequired: 2 },
  { weaponId: 'rpg', killsRequired: 2 },
  { weaponId: 'sword', killsRequired: 1 },
] as const;

export const ARMS_RACE_RESPAWN_TICKS = 75;
export const ARMS_RACE_RINGOUT_TICKS = 90;

export type ArmsRaceProgress = {
  winner: number;
  players: { slot: number; stage: number; stageKills: number; totalKills: number }[];
};

/** Captured at emission, never inferred from whatever the attacker holds at impact time. */
export type DamageCredit = { weaponDef: number; stage: number };
